import React from "react";
import { Helmet } from 'react-helmet';
import "./PrivacyPolicy.css";
import { useNavigate } from "react-router-dom";

function CancellationPolicy() {
  const navigate = useNavigate();

  return (
    <div className="privacy-policy-container">
      <Helmet>
        <title>Cancellation Policy | VaahanBuddy - Vehicle Services in India</title>
        <meta name="description" content="VaahanBuddy's Cancellation Policy outlines the conditions under which services and payments can be cancelled for challan payments and vehicle services." />
        <meta name="keywords" content="VaahanBuddy cancellation policy, cancel challan payment, cancel vehicle services, RTO services cancellation" />
        <meta property="og:title" content="Cancellation Policy | VaahanBuddy" />
        <meta property="og:description" content="Understand VaahanBuddy's cancellation policy for challan payments and vehicle services." />
        <meta property="og:url" content="https://www.vaahanbuddy.com/cancellation-policy" />
      </Helmet>
      <div className="privacy-policy-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <span className="back-arrow">←</span> Back
        </button>
        <h1>Cancellation Policy</h1>
      </div>
      <div className="privacy-policy-content">
        <section>
          <h2>1. Overview</h2>
          <p><strong>Effective Date: June 2025</strong></p>
          <p>
            This Cancellation Policy explains the terms and conditions under which you may cancel a service request or payment made through the VaahanBuddy platform. Please read this policy carefully before making a transaction.
          </p>
        </section>

        <section>
          <h2>2. Cancellation Before Payment Processing</h2>
          <ul>
            <li><strong>Before Payment Initiation:</strong> You may cancel your service request at any time before initiating the payment. No charges will apply in this case.</li>
            <li><strong>During Payment Gateway:</strong> If you close the payment window (Razorpay) before completing the transaction, no amount will be deducted and the order will be automatically cancelled.</li>
          </ul>
        </section>

        <section>
          <h2>3. Cancellation After Payment</h2>
          <div className="important-disclaimer">
            <h3>⚠️ Important:</h3>
            <p>
              <strong>Once a payment has been successfully processed and confirmed, the transaction cannot be cancelled.</strong> This is because challan payments are forwarded directly to government authorities/traffic departments for settlement, and the process cannot be reversed once initiated.
            </p>
          </div>
          <ul>
            <li><strong>Online Challans:</strong> Once payment is confirmed, the challan settlement process begins immediately and cannot be cancelled. The settlement typically takes 10-12 working days.</li>
            <li><strong>Court Challans:</strong> Once payment is confirmed, VaahanBuddy's Legal Partner begins the court representation process. This cannot be cancelled after initiation. Settlement may take 60-90 working days.</li>
            <li><strong>Lok Adalat Matters:</strong> Challan payment success cannot be guaranteed due to the token-based system. In case of unsuccessful Lok Adalat proceedings, alternative payment through virtual court will be attempted.</li>
          </ul>
        </section>

        <section>
          <h2>4. Service Fee Cancellation</h2>
          <p>
            The VaahanBuddy convenience/service fee is non-refundable and non-cancellable once the payment has been successfully processed. The service fee covers the cost of processing, legal partner coordination, and platform maintenance.
          </p>
        </section>

        <section>
          <h2>5. Cancellation by VaahanBuddy</h2>
          <p>
            VaahanBuddy reserves the right to cancel a service request under the following circumstances:
          </p>
          <ul>
            <li><strong>Invalid Information:</strong> If the vehicle number, challan details, or personal information provided is found to be incorrect or fraudulent.</li>
            <li><strong>Court Appearance Required:</strong> If you are required to appear in court personally, the Legal Partner will abstain from paying your challan.</li>
            <li><strong>Technical Issues:</strong> In rare cases of system failure or payment gateway issues preventing service delivery.</li>
            <li><strong>Regulatory Compliance:</strong> If processing the request would violate any applicable law or regulation.</li>
          </ul>
          <p>
            In all cases where VaahanBuddy initiates the cancellation, a <strong>full refund</strong> (including service fees) will be processed within 7 working days.
          </p>
        </section>

        <section>
          <h2>6. How to Request Cancellation</h2>
          <p>
            If you believe your transaction is eligible for cancellation, please contact us immediately with:
          </p>
          <ul>
            <li>Transaction ID / Order ID</li>
            <li>Vehicle Number</li>
            <li>Registered Phone Number</li>
            <li>Reason for cancellation</li>
          </ul>
          <p>
            Our support team will review your request and respond within 24-48 business hours.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <ul className="contact-list">
            <li><strong>📧 Email:</strong> hello@vaahanbuddy.com</li>
            <li><strong>📞 Phone:</strong> +91 95544 94415</li>
            <li><strong>⏰ Response Time:</strong> 24-48 Business Hours</li>
            <li>
              <strong>🏢 Address:</strong> Shop No - 42 First Floor, GDA Commercial Complex, Buddha Vihar Part-A, Taramandal Gorakhpur, U.P. - 273016
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default CancellationPolicy;
